import { ApiError } from "./api";

export const DEMO_RESET_FALLBACK_MESSAGE =
  "Demo reset could not be completed. Existing server data was kept; reload and try again.";

/** Preserve an explicit API refusal at the operator surface instead of silently falling back. */
export function demoResetFailureMessage(error: unknown): string {
  if (error instanceof ApiError && error.body && typeof error.body === "object") {
    const detail = (error.body as { detail?: unknown }).detail;
    if (typeof detail === "string" && detail.trim()) {
      return detail;
    }
  }

  return DEMO_RESET_FALLBACK_MESSAGE;
}

/**
 * True when the server DELIBERATELY refused, as opposed to being unreachable.
 *
 * B4 (PROVIDER-REVIEW-PR339): these two outcomes must not share a code path.
 *
 *   409 refusal   the server declined and deleted NOTHING. Local state is still
 *                 correct. Replaying the reset locally would mutate the very
 *                 rows the refusal exists to protect — and worse, that mutation
 *                 fires 054's and 060's triggers, appending to the exact ledgers
 *                 the refusal message claims were left alone.
 *   anything else transport error, timeout, 500. Server state is unknown, and
 *                 the local replay is the intended demo-continuity fallback.
 *
 * Conflating them produced the failure the packet was written to remove: an
 * amber "reset refused, history preserved" banner sitting on top of a dashboard
 * that had visibly reset.
 */
export function isDemoResetRefusal(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409;
}
